import * as Colors from '../../../consts/variables';
import * as React from 'react';

import { RootStateOrAny, useSelector } from 'react-redux';
import { readCookie, writeCookie } from '../../../helpers/cookie';

import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { CrossIcon } from '../../Icons/CrossIcon';
import { PDFDownloadIcon } from '../../Icons/PDFDownloadIcon';
import { __ } from '../../../helpers/TranslationService';
import { eventTracker } from '../../../helpers/EventTracker/EventTracker';
import useOnclickOutside from 'react-cool-onclickoutside';
import { validateEmail } from '../../../helpers/validation';

interface IPDFButton {
    cruiseNid: number;
}

const PDFButton = (props: IPDFButton) => {
    const { cruiseNid } = props;
    const [isModalOpen, toggleModalOpen] = React.useState<boolean>(false);
    const [actualStep, setActualStep] = React.useState<number>(1);
    const { canonicalUrl } = useSelector((state: RootStateOrAny) => state.cruisePage);

    const ref = useOnclickOutside(() => {
        if (isModalOpen) {
            toggleModalOpen(false);
        }
    });

    const email = readCookie('emailAdressCurrentUser');

    React.useEffect(() => {
        if (isModalOpen) {
            eventTracker.track({
                category: 'cruise-pdf',
                action: 'request-pdf-before-email',
                label: canonicalUrl,
            });
        }
    }, [isModalOpen]);

    return (
        <div ref={ref} className="btn-pdf-download__container">
            <button
                data-testid="btn-pdf-download"
                className="btn-pdf-download"
                onClick={(evt) => !isModalOpen && toggleModalOpen(true)}
            >
                <div className="vcenter action-icon">
                    <PDFDownloadIcon style={{ fill: Colors.softBlack }} />
                </div>
                <span className="text-center vcenter">{__('Download PDF', 'dreamlines')}</span>
            </button>
            {isModalOpen && (
                <PDFModal
                    defaultEmail={email}
                    cruiseNid={cruiseNid}
                    actualStep={actualStep}
                    onStepChange={setActualStep}
                    onCloseClick={toggleModalOpen}
                />
            )}
        </div>
    );
};

interface IPDFModal {
    defaultEmail: string;
    cruiseNid: number;
    actualStep: number;
    onCloseClick: (toggle: boolean) => void;
    onStepChange: (step: number) => void;
}
const PDFModal = (props: IPDFModal) => {
    const { defaultEmail, cruiseNid, actualStep, onCloseClick, onStepChange } = props;
    const [email, setEmail] = React.useState<string>(defaultEmail);
    const [hasError, setHasError] = React.useState<boolean>(false);
    const { canonicalUrl } = useSelector((state: RootStateOrAny) => state.cruisePage);
    const openPDFtab = (): void => {
        eventTracker.track({
            category: 'cruise-pdf',
            action: 'request-pdf-after-email',
            label: canonicalUrl,
        });

        window.open(`/cruise-pdf?cruise=${cruiseNid}`);
    };
    const checkIfValidEmail = (): void => {
        if (!validateEmail(email)) {
            setHasError(true);
            return;
        }
        setHasError(false);
        if (email !== defaultEmail) {
            writeCookie('emailAdressCurrentUser', email);
        }
        eventTracker.track({
            category: 'cruise-pdf',
            action: 'submit-email',
            label: canonicalUrl,
        });
        onStepChange(2);
    };
    return (
        <div
            data-testid="btn-pdf-download__pdf-modal"
            id="btn-pdf-download__pdf-modal"
            onClick={(evt) => evt.stopPropagation()}
        >
            <button
                id="btn-pdf-download__pdf-modal__close"
                className="unstyled_button"
                onClick={(evt) => onCloseClick(false)}
            >
                <CrossIcon width={10} height={10} />
            </button>
            <h2>{__('Download PDF', 'dreamlines')}</h2>
            {actualStep === 1 ? (
                <>
                    <p>
                        {__(
                            'you are just one step apart from downloading this Trip PDF. Just insert your mail address, press submit and get your free download!',
                            'dreamlines',
                        )}
                    </p>
                    {hasError && (
                        <p
                            id="pdf-modal__email-address__error"
                            data-testid="pdf-modal__email-address__error"
                        >
                            {__('incorrect email', 'dreamlines')}
                        </p>
                    )}
                    <div id="btn-pdf-download__pdf-modal__inline-form">
                        <input
                            className={hasError ? 'error_animation' : ''}
                            id="pdf-modal__email-address"
                            data-testid="pdf-modal__email-address"
                            placeholder={__('your mail address', 'dreamlines')}
                            type="text"
                            onBlur={(evt) => setEmail(evt.target.value)}
                            defaultValue={email}
                        />
                        <button
                            onClick={(evt) => checkIfValidEmail()}
                            data-testid="pdf-modal__request-pdf"
                            className="blue_button minor has_hover with_arrow w-100"
                        >
                            {__('Send', 'dreamlines')}
                            <ArrowRightIcon width={15} height={25} />
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <p>
                        {__(
                            'you have access to the Trip PDF now. Just press the Download button to receive it.',
                            'dreamlines',
                        )}
                    </p>
                    <button
                        onClick={(evt) => openPDFtab()}
                        data-testid="pdf-modal__download-pdf"
                        className="blue_button bigger inline-icon has_hover w-100"
                    >
                        <PDFDownloadIcon width={18} height={18} />
                        {__('Download PDF Button Text', 'dreamlines')}
                    </button>
                </>
            )}
        </div>
    );
};

export default PDFButton;
